import { Routes, Route, useLocation , Navigate} from "react-router-dom";

import './App.css';
import { useState } from "react";

import { ColorModeContext, useMode } from "./theme";
import Sidebar from "./pages/Sidebar";
import { CssBaseline, ThemeProvider } from "@mui/material";
import LoginPage from "./pages/LoginNew";
import LandingPage from "./pages/LandingPageNew";
import { useSelector } from "react-redux";
import React from "react";

import MaintenanceHome from "./mis/scenes/MaintenaceHome";
import EfficiencyHome from "./mis/scenes/EfficiencyHome";
import TableEfficiency from "./mis/components/TableSupply";
import UsersHome from "./mis/scenes/UsersHome";
import ExcelUploader from './mis/components/TableUpload';
import Add from "./mis/pages/Add";
import SupplyAdd from "./mis/pages/SupplyAdd";
import Edit from "./mis/pages/Edit";
import SupplyEdit from "./mis/pages/SupplyEdit";
import ComplaintsEdit from "./mis/pages/ComplaintsEdit";
import TableBasic from "./mis/components/TableBasic";
import ProductVendorDataGrid from './inventory/components/ProductVendorDataGrid';
import ProductList from './inventory/components/ProductList';
import VendorList from './inventory/components/VendorList';
import IssueReceiveTable from './inventory/components/IssueReceiveTable'

import MachineList from './production/components/MachineList';
import SectionWiseMachine from './production/components/SectionWiseMachine';
import ProductionPlan from './production/components/ProductionPlan';
import CreateJobCard from "./production/components/CreateJobCard";
import ViewJobCard from "./production/components/ViewJobCard";
import CreateProductionPlan from "./production/components/CreateProductionPlan";
import ProcessSteps from './production/components/ProcessSteps';
import TableTemplate from './production/components/TableTemplate';
import ProductionTabs from "./production/components/ProductionTabs";
import ProductWiseMachine from './production/components/ProductWiseMachine';
import MainProduct from './production/components/MainProduct';

import ProductionLocInventory from './production/components/ProductionLocInventory';
import FinishedGoodInventory from './production/components/FinishedGoodInventory';
import SemiFinishedGoodInventory from './production/components/SemiFinishedGoodInventory';
import RejectedFinishedProduct from './production/components/RejectedFinishedProduct';
import RejectedSemiFinishedProduct from './production/components/RejectedSemiFinishedProduct';
import ViewBOM from './production/components/ViewBOM';
import ProductTabs from './production/components/ProductTabs';
import ProductionSteps from './production/components/ProductionSteps';
import StepwiseInventory from './production/components/StepwiseInventory';
import RejectedRawMaterials from './production/components/RejectedRawMaterials';

import InventoryHome from "./inventory/scenes/InventoryHome"
import IssueReceiveItemHome from "./inventory/scenes/IssueReceiveItemHome";
import RawMaterialHome from "./inventory/scenes/RawMaterialHome";
import VendorHome from "./inventory/scenes/VendorHome";

function HealthCheck() {
  return <div>healthy</div>;
}


function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const mode = useSelector((state) => state.mode);
  const isAuth = Boolean(useSelector((state) => state.token));
  const location = useLocation();
  
  if (location.pathname === "/health") {
    return <HealthCheck />;
  }


  // Function to check if the current location matches certain paths
  const shouldShowSidebar = () => {
    const { pathname } = location;
    return !['/login', '/'].includes(pathname);
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {shouldShowSidebar() && <Sidebar />} 
          
          <main className="content">   
            <Routes>            
              <Route path="/maintenanceHome" element={isAuth ? <MaintenanceHome /> : <Navigate to="/" />} />
              <Route path="/efficiencyHome" element={isAuth ? <EfficiencyHome /> : <Navigate to="/" />} />
              <Route path="/maintenanceHome/:tabIndex?" element={isAuth ? <MaintenanceHome /> : <Navigate to="/" />}/>
              <Route path="/maintenanceHome/add" element={isAuth ? <Add /> : <Navigate to="/" />}/>
              <Route path="/efficiencyHome/add" element={isAuth ? <SupplyAdd /> : <Navigate to="/" />} />
              <Route path="/efficiencyHome/:tabIndex?" element={isAuth ? <EfficiencyHome /> : <Navigate to="/" />} />
              <Route path="/edit/:rowIndex" element={isAuth ? <Edit /> : <Navigate to="/" />} />
              <Route path="/editEfficiency/:rowIndex" element={isAuth ? <SupplyEdit /> : <Navigate to="/" />}/>
              <Route path="/editComplaints/:rowIndex" element={isAuth ? <ComplaintsEdit /> : <Navigate to="/" />}/>
              <Route path="/table" element={isAuth ? <TableBasic /> : <Navigate to="/" />} />
              <Route path="/tableEfficiency" element={isAuth ? <TableEfficiency /> : <Navigate to="/" />} />
              <Route path="/register" element={isAuth ? <UsersHome /> : <Navigate to="/" />} />
              <Route path="/upload" element={isAuth ? <ExcelUploader /> : <Navigate to="/" />} />
              <Route path="/editComp" element={isAuth ? <ComplaintsEdit /> : <Navigate to="/" />} />
              <Route path="/inventory" element={isAuth ? <ProductVendorDataGrid /> : <Navigate to="/" />} />
              <Route path="/products" element={isAuth ? <ProductList /> : <Navigate to="/" />} />
              <Route path="/vendors" element={isAuth ? <VendorList /> : <Navigate to="/" />} />
              <Route path="/issue-receive-items" element={isAuth ? <IssueReceiveTable /> : <Navigate to="/" />} />

              <Route path="/machinelist" element={isAuth ? <MachineList /> : <Navigate to="/" />} />
                <Route path="/sectionwisemachine" element={isAuth ? <SectionWiseMachine />: <Navigate to="/" />} />
                <Route path="/production-plan" element={isAuth ? <ProductionPlan /> : <Navigate to="/" />} />
                <Route path="/create-job-card/:id" element={isAuth ? <CreateJobCard /> : <Navigate to="/" />} />
                <Route path="/view-job-card/:plan_id" element={isAuth ? <ViewJobCard /> : <Navigate to="/" />} />
                <Route path="/create-production-plan" element={isAuth ? <CreateProductionPlan /> : <Navigate to="/" />} />
                <Route path="/process-steps" element={isAuth ? <ProcessSteps /> : <Navigate to="/" />} />
                <Route path="/table-template" element={isAuth ? <TableTemplate /> : <Navigate to="/" />} />
                <Route path="/production-tabs" element={isAuth ? <ProductionTabs /> : <Navigate to="/" />} />
                <Route path="/product-wise-machine" element={isAuth ? <ProductWiseMachine /> : <Navigate to="/" />} />
                <Route path="/main-product" element={isAuth ? <MainProduct /> : <Navigate to="/" />} />
                <Route path="/production-loc-inventory" element={isAuth ? <ProductionLocInventory /> : <Navigate to="/" />} />
                <Route path="/finished-product" element={isAuth ? < FinishedGoodInventory/> : <Navigate to="/" />} />
                <Route path="/semi-finished-product" element={isAuth ? <SemiFinishedGoodInventory /> : <Navigate to="/" />} />
                <Route path="/rejected-finished-product" element={isAuth ? <RejectedFinishedProduct /> : <Navigate to="/" />} />
                <Route path="/rejected-semi-finished-product" element={isAuth ? <RejectedSemiFinishedProduct /> : <Navigate to="/" />} />
                <Route path="/view-BOM" element={isAuth ? <ViewBOM /> : <Navigate to="/" />} />
                <Route path="/product-tabs" element={isAuth ? <ProductTabs /> : <Navigate to="/" />} />
                <Route path="/production-steps" element={isAuth ? <ProductionSteps /> : <Navigate to="/" />} />
                <Route path="/stepwise-inv" element={isAuth ? <StepwiseInventory /> : <Navigate to="/" />} />
                <Route path="/rejected-raw-materials" element={isAuth ? <RejectedRawMaterials /> : <Navigate to="/" />} />

                <Route path="/inventoryHome" element={isAuth ? <InventoryHome /> : <Navigate to="/" />} />
                <Route path="/rawMaterialHome" element={isAuth ? <RawMaterialHome /> : <Navigate to="/" />} />
                <Route path="/vendorHome" element={isAuth ? <VendorHome /> : <Navigate to="/" />} />
                <Route path="/issueReceiveItemHome" element={isAuth ? <IssueReceiveItemHome /> : <Navigate to="/" />} />

              <Route path="/home" element={isAuth ? <LandingPage /> : <Navigate to="/" />} />

              <Route path="/" element={<LoginPage />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
